// AdminPanel/OrgResultCard — one result row shared by the Org ID and Email
// finders. Extracted so the two finders stay independent components without
// duplicating the card, which is the only part of them that is genuinely the
// same.
import React from 'react';
import PropTypes from 'prop-types';
import {Box, Button, Card, CardContent, Typography} from '@mui/material';

// The details dialog expects the row shape the Customers table passes it
// (keyed on instituteId). Prefer the already-loaded row so nothing the list
// enriched is lost; fall back to the search result, which the dialog can
// fetch the rest from.
function OrgResultCard({org, orgs, onOpenOrg}) {
  const contactName = org.contactName || org.onboarding?.contactName;
  const email = org.onboarding?.contactEmail;
  const open = () => {
    const loaded = orgs?.find((x) => x.instituteId === org.id);
    onOpenOrg(loaded || {...org, instituteId: org.id});
  };

  return (
    <Card sx={{border: '1px solid #c8e6c9', mb: 1}}>
      <CardContent>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap'}}>
          <Box sx={{minWidth: 0}}>
            <Typography variant="h6">{org.name || contactName || org.id}</Typography>
            {contactName && (
              <Typography variant="body2" color="text.secondary">{contactName}</Typography>
            )}
            {email && (
              <Typography variant="body2" color="text.secondary">{email}</Typography>
            )}
            <Typography variant="caption" color="text.secondary" component="div">
              Tenant: <code>{org.id}</code>{org.accountStatus ? ` · ${org.accountStatus}` : ''}
            </Typography>
          </Box>
          <Button variant="contained" onClick={open} sx={{flexShrink: 0}}>
            Open Org Details
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

OrgResultCard.propTypes = {
  org: PropTypes.object.isRequired,
  orgs: PropTypes.array,
  onOpenOrg: PropTypes.func.isRequired
};

export default OrgResultCard;
